'use client';

import Icon from '@/components/ui/AppIcon';

export default function EmergencyContactSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-error to-error/80 rounded-2xl p-8 lg:p-12 text-white shadow-premium">
            <div className="flex items-start space-x-6">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="ExclamationTriangleIcon" size={32} className="text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl lg:text-3xl font-display font-bold mb-4">Emergency Contact</h3>
                <p className="text-white/90 mb-6">
                  For urgent matters requiring immediate assistance, our 24/7 emergency support team is always available.
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <a
                    href="tel:+917259252233"
                    className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 rounded-lg p-4 transition-all duration-300"
                  >
                    <Icon name="PhoneIcon" size={24} className="text-white" />
                    <div>
                      <p className="text-sm text-white/80">Emergency Hotline</p>
                      <p className="font-semibold">+91 72592 52233</p>
                    </div>
                  </a>
                  <a
                    href="https://wa.me/917022598485"
                    className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 rounded-lg p-4 transition-all duration-300"
                  >
                    <Icon name="ChatBubbleLeftRightIcon" size={24} className="text-white" />
                    <div>
                      <p className="text-sm text-white/80">WhatsApp Emergency</p>
                      <p className="font-semibold">+91 70225 98485</p>
                    </div>
                  </a>
                </div>
                <div className="mt-6 flex items-start space-x-2">
                  <Icon name="CheckCircleIcon" size={20} className="text-white flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-white/90">
                    Available 24/7 for medical emergencies, security concerns, maintenance issues, and any urgent guest needs.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-primary/5 border border-primary/20 rounded-xl p-8">
            <div className="text-center">
              <Icon name="HeartIcon" size={32} className="text-accent mx-auto mb-4" />
              <h4 className="text-xl font-display font-semibold text-text-primary mb-2">
                We're Here for You
              </h4>
              <p className="text-text-secondary max-w-2xl mx-auto">
                Your comfort and safety are our top priorities. Whether you need assistance with your stay, have questions about our services, or want to explore corporate partnership opportunities, our dedicated team is ready to help.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}